var Sections = {
  Introductory: "6",
  Summary: "8",
  Idera: "9",
  Liens: "10",
  Detention: "11",
  Comments: "12",
  VariableB: "14",
  ProtectionismA: "16",
  ProtectionismB: "17",
  ProtectionismC: "18",
  ProtectionismD: "19",
  ContractInterpretation: "20",
  Enforcement: "21",
  NonBankruptcy: "22",
  Bankruptcy: "23"
}
export default Sections;
